// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2ksfB","title":"Info_title__yYdYy","selects":"Info_selects__rsm9Y","requiredAsterisk":"Info_requiredAsterisk__8i_LJ"};